import { useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../constants/Context";
import { logPlayCricketResponse } from "../utils/playCricketLogger";
const ResultAPI = ({
  siteId, 
  season, 
  fromMatchDate, 
  endMatchDate, 
  divisionId, 
  onDataLoaded, 
  onError, 
  onLoading,
  fetchImmediately = true,
  autoPoll = false
}) => {
  const { API_TOKEN } = useContext(GlobalContext);
  const POLLING_INTERVAL = 15000;
  
  const fetchResults = useCallback(async () => {
    if (!siteId || !season) {
      console.warn("Site ID or Season missing");
      return;
    }

    let url = `https://play-cricket.com/api/v2/result_summary.json?site_id=${siteId}&season=${season}&api_token=${API_TOKEN}`;
    
    if (fromMatchDate) {
      url += `&from_match_date=${fromMatchDate}`;
    }
    
    if (endMatchDate) {
      url += `&end_match_date=${endMatchDate}`;
    }
    
    if (divisionId && divisionId !== "all") {
      url += `&division_id=${divisionId}`;
    }

    try {
      onLoading(true);

      const response = await axios.get(url, {
        timeout: 10000,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      logPlayCricketResponse({
        endpoint: "result_summary",
        requestUrl: url,
        httpStatus: response.status,
        isSuccess: true,
        rawResponse: response.data,
      });

      if (response.data && response.data.result_summary) {
        const resultsData = response.data.result_summary;
        onDataLoaded(resultsData);
      } else {
        onDataLoaded([]);
      }
      
      onLoading(false);
    } catch (err) {
      console.error("ResultAPI Error:", err);

      logPlayCricketResponse({
        endpoint: "result_summary",
        requestUrl: url,
        httpStatus: err.response?.status || null,
        isSuccess: false,
        rawResponse: err.response?.data || null,
        errorMessage: err.message,
      });
      
      let errorMsg = "Failed to fetch match results";
      if (err.response) {
        errorMsg = `Server error: ${err.response.status}`;
        if (err.response.data && err.response.data.error) {
          errorMsg = err.response.data.error;
        }
      } else if (err.request) {
        errorMsg = "No response from server - Check network connection";
      } else if (err.code === "ECONNABORTED") {
        errorMsg = "Request timeout - Server is taking too long to respond";
      }
      
      onError(errorMsg);
      onLoading(false);
    }
  }, [siteId, season, fromMatchDate, endMatchDate, divisionId, onDataLoaded, onError, onLoading]);

  useEffect(() => {
    
    if (fetchImmediately) {
      fetchResults();
    }

    let intervalId;
    if (autoPoll) {
      intervalId = setInterval(fetchResults, POLLING_INTERVAL);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [fetchResults, fetchImmediately, autoPoll]); 

  return null;
};

export default ResultAPI;